/* tslint:disable */
/* eslint-disable */
export enum WorkCronjobRunStatusEnum {
  Running = 'running',
  Success = 'success',
  Error = 'error',
  Aborted = 'aborted'
}
